export default (state, value) => {
	console.info('🦑 SET_DISMISS_MIXED_OWNERSHIP', { value });
	state.dismissMixedOwnership = value;
};
